// import React from 'react';
// import { useQuery } from '@tanstack/react-query';
// import { getCompany } from '../../network/profile';
// import { useSelector } from 'react-redux';
// import { Button, Card, Descriptions, Spin, Row, Col } from 'antd';
// import { queryKeys } from '../../services/react-query/queryKeys';
// import { EditOutlined } from '@ant-design/icons';
// import { useNavigate } from 'react-router-dom';

// const Profile = ({ t }) => {
//   const navigate = useNavigate();
//   const { companyName } = useSelector((state) => state.user);

//   const { data, isLoading } = useQuery({
//     queryKey: [queryKeys.getCompany],
//     queryFn: () => getCompany(companyName),
//     keepPreviousData: true,
//   });

//   if (isLoading) {
//     return (
//       <div
//         style={{
//           width: '100%',
//           height: '100vh',
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//         }}
//       >
//         <Spin size="large" />
//       </div>
//     );
//   }

//   const {
//     company_name,
//     company_name_in_arabic,
//     abbr,
//     default_currency,
//     country,
//     default_holiday_list,
//     tax_id,
//     date_of_establishment,
//     custom_cr_number,
//     phone_no,
//     email,
//     company_description,
//     website,
//     monthly_sales_target,
//     total_monthly_sales,
//     credit_limit,
//     custom_default_down_payment_item,
//     default_bank_account,
//     default_cash_account,
//     default_receivable_account,
//     round_off_account,
//     round_off_cost_center,
//     write_off_account,
//     exchange_gain_loss_account,
//     custom_advance_payment_account,
//     unrealized_profit_loss_account,
//     default_payable_account,
//     default_expense_account,
//     default_income_account,
//     default_deferred_revenue_account,
//     default_deferred_expense_account,
//     default_discount_account,
//     cost_center,
//     enable_perpetual_inventory,
//     enable_provisional_accounting_for_non_stock_items,
//     default_inventory_account,
//     stock_adjustment_account,
//     stock_received_but_not_billed,
//     default_provisional_account,
//     accumulated_depreciation_account,
//     depreciation_expense_account,
//     series_for_depreciation_entry,
//     disposal_account,
//     depreciation_cost_center,
//     capital_work_in_progress_account,
//     asset_received_but_not_billed,
//     auto_exchange_rate_revaluation,
//     auto_err_frequency,
//   } = data?.data || {};

//   return (
//     <div style={{ padding: '20px' }}>
//       <Card
//         title={t.profile}
//         extra={
//           <Button
//             type="primary"
//             size="small"
//             onClick={() => navigate(`/profile/${company_name}`)}
//             icon={<EditOutlined />}
//           >
//             {t.edit}
//           </Button>
//         }
//         bordered={false}
//       >
//         {/* معلومات الشركة */}
//         <Card title={t.companySettings} bordered>
//           <Descriptions bordered column={2} size="middle">
//             <Descriptions.Item label={t.companyName}>
//               {company_name || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.companyNameInArabic}>
//               {company_name_in_arabic || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.abbr}>
//               {abbr || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.defaultCurrency}>
//               {default_currency || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.country}>
//               {country || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.defaultHolidayList}>
//               {default_holiday_list || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.taxId}>
//               {tax_id || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.dateOfEstablishment}>
//               {date_of_establishment || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.crNumber}>
//               {custom_cr_number || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.Phone}>
//               {phone_no || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.email}>
//               {email || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.website}>
//               {website || t.notAvailable}
//             </Descriptions.Item>
//           </Descriptions>
//         </Card>

//         {/* إعدادات البيع والشراء */}
//         <Card title={t.salesSettings} bordered style={{ marginTop: '20px' }}>
//           <Descriptions bordered column={2} size="middle">
//             <Descriptions.Item label={t.totalMonthlySales}>
//               {total_monthly_sales || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.monthlySalesTarget}>
//               {monthly_sales_target || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.creditLimit}>
//               {credit_limit || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.downPaymentItem}>
//               {custom_default_down_payment_item || t.notAvailable}
//             </Descriptions.Item>
//           </Descriptions>
//         </Card>

//         {/* إعدادات الحسابات */}
//         <Card title={t.accountSettings} bordered style={{ marginTop: '20px' }}>
//           <Descriptions bordered column={2} size="middle">
//             <Descriptions.Item label={t.defaultBankAccount}>
//               {default_bank_account || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.defaultCashAccount}>
//               {default_cash_account || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.defaultReceivableAccount}>
//               {default_receivable_account || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.roundOffAccount}>
//               {round_off_account || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.roundOffCostCenter}>
//               {round_off_cost_center || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.writeOffAccount}>
//               {write_off_account || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.exchangeGainLossAccount}>
//               {exchange_gain_loss_account || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.advancePaymentAccount}>
//               {custom_advance_payment_account || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.unrealizedProfitLossAccount}>
//               {unrealized_profit_loss_account || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.defaultPayableAccount}>
//               {default_payable_account || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.defaultExpenseAccount}>
//               {default_expense_account || t.notAvailable}
//             </Descriptions.Item>
//           </Descriptions>
//         </Card>

//         {/* إعدادات المخزون */}
//         <Card
//           title={t.inventorySettings}
//           bordered
//           style={{ marginTop: '20px' }}
//         >
//           <Descriptions bordered column={2} size="middle">
//             <Descriptions.Item label={t.defaultInventoryAccount}>
//               {default_inventory_account || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.stockReceivedButNotBilled}>
//               {stock_received_but_not_billed || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.stockAdjustmentAccount}>
//               {stock_adjustment_account || t.notAvailable}
//             </Descriptions.Item>
//           </Descriptions>
//         </Card>

//         {/* إعدادات الأصول الثابتة */}
//         <Card
//           title={t.fixedAssetsSettings}
//           bordered
//           style={{ marginTop: '20px' }}
//         >
//           <Descriptions bordered column={2} size="middle">
//             <Descriptions.Item label={t.accumulatedDepreciationAccount}>
//               {accumulated_depreciation_account || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.depreciationExpenseAccount}>
//               {depreciation_expense_account || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.seriesForDepreciationEntry}>
//               {series_for_depreciation_entry || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.disposalAccount}>
//               {disposal_account || t.notAvailable}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.depreciationCostCenter}>
//               {depreciation_cost_center || t.notAvailable}
//             </Descriptions.Item>
//           </Descriptions>
//         </Card>

//         {/* الإعدادات الإضافية */}
//         <Card
//           title={t.additionalSettings}
//           bordered
//           style={{ marginTop: '20px' }}
//         >
//           <Descriptions bordered column={2} size="middle">
//             <Descriptions.Item label={t.autoExchangeRateRevaluation}>
//               {auto_exchange_rate_revaluation ? 'Yes' : 'No'}
//             </Descriptions.Item>
//             <Descriptions.Item label={t.autoErrFrequency}>
//               {auto_err_frequency || t.notAvailable}
//             </Descriptions.Item>
//           </Descriptions>
//         </Card>
//       </Card>
//     </div>
//   );
// };

// export default Profile;

// import React from 'react';
// import { useQuery } from '@tanstack/react-query';
// import { getCompany } from '../../network/profile';
// import { useSelector } from 'react-redux';
// import {
//   Button,
//   Card,
//   Descriptions,
//   Spin,
//   Tabs,
//   Row,
//   Col,
//   Typography,
// } from 'antd';
// import {
//   EditOutlined,
//   BankOutlined,
//   BarChartOutlined,
//   SettingOutlined,
//   AppstoreOutlined,
//   FileSearchOutlined,
// } from '@ant-design/icons';
// import { useNavigate } from 'react-router-dom';
// import { queryKeys } from '../../services/react-query/queryKeys';

// const { Title } = Typography;

// const Section = ({ title, icon, children }) => (
//   <Card
//     title={
//       <span>
//         {icon} <span style={{ marginLeft: 8 }}>{title}</span>
//       </span>
//     }
//     bordered
//     style={{ marginBottom: 20 }}
//   >
//     {children}
//   </Card>
// );

// const Profile = ({ t }) => {
//   const navigate = useNavigate();
//   const { companyName } = useSelector((state) => state.user);

//   const { data, isLoading } = useQuery({
//     queryKey: [queryKeys.getCompany],
//     queryFn: () => getCompany(companyName),
//     keepPreviousData: true,
//   });

//   if (isLoading) {
//     return (
//       <div
//         style={{
//           width: '100%',
//           height: '100vh',
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//         }}
//       >
//         <Spin size="large" />
//       </div>
//     );
//   }

//   const company = data?.data || {};

//   const renderDescriptions = (fields) => (
//     <Descriptions column={2} bordered size="small">
//       {fields.map(({ label, key }) => (
//         <Descriptions.Item label={label} key={key}>
//           {company[key] || t.notAvailable}
//         </Descriptions.Item>
//       ))}
//     </Descriptions>
//   );

//   return (
//     <Card bordered className="mt-10 min-h-[50vh]">
//       <Row justify="space-between" align="middle" style={{ marginBottom: 24 }}>
//         <Title level={3}>{t.profile}</Title>
//         <Button
//           type="primary"
//           icon={<EditOutlined />}
//           onClick={() => navigate(`/profile/${company.company_name}`)}
//         >
//           {t.edit}
//         </Button>
//       </Row>

//       <Tabs defaultActiveKey="1" type="card" size="large">
//         <Tabs.TabPane
//           tab={
//             <span>
//               <BankOutlined />
//               {t.companySettings}
//             </span>
//           }
//           key="1"
//         >
//           {renderDescriptions([
//             { label: t.companyName, key: 'company_name' },
//             { label: t.companyNameInArabic, key: 'company_name_in_arabic' },
//             { label: t.abbr, key: 'abbr' },
//             { label: t.defaultCurrency, key: 'default_currency' },
//             { label: t.country, key: 'country' },
//             { label: t.defaultHolidayList, key: 'default_holiday_list' },
//             { label: t.taxId, key: 'tax_id' },
//             { label: t.dateOfEstablishment, key: 'date_of_establishment' },
//             { label: t.crNumber, key: 'custom_cr_number' },
//             { label: t.Phone, key: 'phone_no' },
//             { label: t.email, key: 'email' },
//             { label: t.website, key: 'website' },
//           ])}
//         </Tabs.TabPane>

//         <Tabs.TabPane
//           tab={
//             <span>
//               <BarChartOutlined />
//               {t.salesSettings}
//             </span>
//           }
//           key="2"
//         >
//           {renderDescriptions([
//             { label: t.totalMonthlySales, key: 'total_monthly_sales' },
//             { label: t.monthlySalesTarget, key: 'monthly_sales_target' },
//             { label: t.creditLimit, key: 'credit_limit' },
//             {
//               label: t.downPaymentItem,
//               key: 'custom_default_down_payment_item',
//             },
//           ])}
//         </Tabs.TabPane>

//         <Tabs.TabPane
//           tab={
//             <span>
//               <SettingOutlined />
//               {t.accountSettings}
//             </span>
//           }
//           key="3"
//         >
//           {renderDescriptions([
//             { label: t.defaultBankAccount, key: 'default_bank_account' },
//             { label: t.defaultCashAccount, key: 'default_cash_account' },
//             {
//               label: t.defaultReceivableAccount,
//               key: 'default_receivable_account',
//             },
//             { label: t.roundOffAccount, key: 'round_off_account' },
//             { label: t.roundOffCostCenter, key: 'round_off_cost_center' },
//             { label: t.writeOffAccount, key: 'write_off_account' },
//             {
//               label: t.exchangeGainLossAccount,
//               key: 'exchange_gain_loss_account',
//             },
//             {
//               label: t.advancePaymentAccount,
//               key: 'custom_advance_payment_account',
//             },
//             {
//               label: t.unrealizedProfitLossAccount,
//               key: 'unrealized_profit_loss_account',
//             },
//             { label: t.defaultPayableAccount, key: 'default_payable_account' },
//             { label: t.defaultExpenseAccount, key: 'default_expense_account' },
//           ])}
//         </Tabs.TabPane>

//         <Tabs.TabPane
//           tab={
//             <span>
//               <AppstoreOutlined />
//               {t.inventorySettings}
//             </span>
//           }
//           key="4"
//         >
//           {renderDescriptions([
//             {
//               label: t.defaultInventoryAccount,
//               key: 'default_inventory_account',
//             },
//             {
//               label: t.stockReceivedButNotBilled,
//               key: 'stock_received_but_not_billed',
//             },
//             {
//               label: t.stockAdjustmentAccount,
//               key: 'stock_adjustment_account',
//             },
//           ])}
//         </Tabs.TabPane>

//         <Tabs.TabPane
//           tab={
//             <span>
//               <FileSearchOutlined />
//               {t.fixedAssetsSettings}
//             </span>
//           }
//           key="5"
//         >
//           {renderDescriptions([
//             {
//               label: t.accumulatedDepreciationAccount,
//               key: 'accumulated_depreciation_account',
//             },
//             {
//               label: t.depreciationExpenseAccount,
//               key: 'depreciation_expense_account',
//             },
//             {
//               label: t.seriesForDepreciationEntry,
//               key: 'series_for_depreciation_entry',
//             },
//             { label: t.disposalAccount, key: 'disposal_account' },
//             {
//               label: t.depreciationCostCenter,
//               key: 'depreciation_cost_center',
//             },
//           ])}
//         </Tabs.TabPane>

//         <Tabs.TabPane tab={<span>⚙️ {t.additionalSettings}</span>} key="6">
//           {renderDescriptions([
//             {
//               label: t.autoExchangeRateRevaluation,
//               key: 'auto_exchange_rate_revaluation',
//             },
//             {
//               label: t.autoErrFrequency,
//               key: 'auto_err_frequency',
//             },
//           ])}
//         </Tabs.TabPane>
//       </Tabs>
//     </Card>
//   );
// };

// export default Profile;

import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { getCompany } from '../../network/profile';
import { useSelector } from 'react-redux';
import { Button, Card, Descriptions, Spin, Tabs, Typography } from 'antd';
import {
  EditOutlined,
  BankOutlined,
  DollarOutlined,
  SettingOutlined,
  AppstoreOutlined,
  ToolOutlined,
  PlusCircleOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { queryKeys } from '../../services/react-query/queryKeys';

const { Title } = Typography;

const Profile = ({ t }) => {
  const navigate = useNavigate();
  const { companyName } = useSelector((state) => state.user);

  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getCompany],
    queryFn: () => getCompany(companyName),
    keepPreviousData: true,
  });

  if (isLoading) {
    return (
      <div
        style={{
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  const info = data?.data || {};

  const renderDescriptions = (fields) => (
    <Descriptions bordered column={2} size="middle">
      {fields.map(({ label, value }) => (
        <Descriptions.Item label={label} key={label}>
          {value ?? t.notAvailable}
        </Descriptions.Item>
      ))}
    </Descriptions>
  );

  const tabsItems = [
    {
      key: '1',
      label: (
        <span>
          <BankOutlined /> {t.companySettings}
        </span>
      ),
      children: renderDescriptions([
        { label: t.companyName, value: info.company_name },
        { label: t.companyNameInArabic, value: info.company_name_in_arabic },
        { label: t.abbr, value: info.abbr },
        { label: t.defaultCurrency, value: info.default_currency },
        { label: t.country, value: info.country },
        { label: t.defaultHolidayList, value: info.default_holiday_list },
        { label: t.taxId, value: info.tax_id },
        { label: t.dateOfEstablishment, value: info.date_of_establishment },
        { label: t.crNumber, value: info.custom_cr_number },
        { label: t.Phone, value: info.phone_no },
        { label: t.email, value: info.email },
        { label: t.website, value: info.website },
      ]),
    },
    {
      key: '2',
      label: (
        <span>
          <DollarOutlined /> {t.salesSettings}
        </span>
      ),
      children: renderDescriptions([
        { label: t.totalMonthlySales, value: info.total_monthly_sales },
        { label: t.monthlySalesTarget, value: info.monthly_sales_target },
        { label: t.creditLimit, value: info.credit_limit },
        {
          label: t.downPaymentItem,
          value: info.custom_default_down_payment_item,
        },
      ]),
    },
    {
      key: '3',
      label: (
        <span>
          <SettingOutlined /> {t.accountSettings}
        </span>
      ),
      children: renderDescriptions([
        { label: t.defaultBankAccount, value: info.default_bank_account },
        { label: t.defaultCashAccount, value: info.default_cash_account },
        {
          label: t.defaultReceivableAccount,
          value: info.default_receivable_account,
        },
        { label: t.roundOffAccount, value: info.round_off_account },
        { label: t.roundOffCostCenter, value: info.round_off_cost_center },
        { label: t.writeOffAccount, value: info.write_off_account },
        {
          label: t.exchangeGainLossAccount,
          value: info.exchange_gain_loss_account,
        },
        {
          label: t.advancePaymentAccount,
          value: info.custom_advance_payment_account,
        },
        {
          label: t.unrealizedProfitLossAccount,
          value: info.unrealized_profit_loss_account,
        },
        { label: t.defaultPayableAccount, value: info.default_payable_account },
        { label: t.defaultExpenseAccount, value: info.default_expense_account },
      ]),
    },
    {
      key: '4',
      label: (
        <span>
          <AppstoreOutlined /> {t.inventorySettings}
        </span>
      ),
      children: renderDescriptions([
        {
          label: t.defaultInventoryAccount,
          value: info.default_inventory_account,
        },
        {
          label: t.stockReceivedButNotBilled,
          value: info.stock_received_but_not_billed,
        },
        {
          label: t.stockAdjustmentAccount,
          value: info.stock_adjustment_account,
        },
      ]),
    },
    {
      key: '5',
      label: (
        <span>
          <ToolOutlined /> {t.fixedAssetsSettings}
        </span>
      ),
      children: renderDescriptions([
        {
          label: t.accumulatedDepreciationAccount,
          value: info.accumulated_depreciation_account,
        },
        {
          label: t.depreciationExpenseAccount,
          value: info.depreciation_expense_account,
        },
        {
          label: t.seriesForDepreciationEntry,
          value: info.series_for_depreciation_entry,
        },
        { label: t.disposalAccount, value: info.disposal_account },
        {
          label: t.depreciationCostCenter,
          value: info.depreciation_cost_center,
        },
      ]),
    },
    {
      key: '6',
      label: (
        <span>
          <PlusCircleOutlined /> {t.additionalSettings}
        </span>
      ),
      children: renderDescriptions([
        {
          label: t.autoExchangeRateRevaluation,
          value: info.auto_exchange_rate_revaluation ? 'Yes' : 'No',
        },
        { label: t.autoErrFrequency, value: info.auto_err_frequency },
      ]),
    },
  ];

  return (
    <div className="mt-5">
      <Card
        title={<Title level={4}>{t.profile}</Title>}
        extra={
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => navigate(`/profile/${info.company_name}`)}
          >
            {t.edit}
          </Button>
        }
      >
        <Tabs defaultActiveKey="1" items={tabsItems} />
      </Card>
    </div>
  );
};

export default Profile;
